var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoReqHistoryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 84,
    viewBox: "0 0 85 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 42.5,
    cy: 42,
    r: 42,
    fill: "url(#paint0_linear_2031_17433)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2031_17433)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7858 28.9999C25.7858 27.9742 26.6172 27.1428 27.6429 27.1428H29.5001C30.5257 27.1428 31.3572 26.3113 31.3572 25.2856C31.3572 24.2599 30.5257 23.4285 29.5001 23.4285H27.6429C24.5659 23.4285 22.0715 25.9229 22.0715 28.9999V62.4285C22.0715 65.5056 24.5659 67.9999 27.6429 67.9999H57.3572C60.4343 67.9999 62.9286 65.5056 62.9286 62.4285V28.9999C62.9286 25.9229 60.4343 23.4285 57.3572 23.4285H55.5C54.4743 23.4285 53.6429 24.2599 53.6429 25.2856C53.6429 26.3113 54.4743 27.1428 55.5 27.1428H57.3572C58.3829 27.1428 59.2143 27.9742 59.2143 28.9999V62.4285C59.2143 63.4542 58.3829 64.2856 57.3572 64.2856H27.6429C26.6172 64.2856 25.7858 63.4542 25.7858 62.4285V28.9999ZM29.5001 41.9999C29.5001 40.9742 30.3315 40.1428 31.3572 40.1428H53.6429C54.6686 40.1428 55.5 40.9742 55.5 41.9999C55.5 43.0256 54.6686 43.857 53.6429 43.857H31.3572C30.3315 43.857 29.5001 43.0256 29.5001 41.9999ZM31.3572 49.4285C30.3315 49.4285 29.5001 50.2599 29.5001 51.2856C29.5001 52.3113 30.3315 53.1428 31.3572 53.1428H44.3572C45.3829 53.1428 46.2143 52.3113 46.2143 51.2856C46.2143 50.2599 45.3829 49.4285 44.3572 49.4285H31.3572Z",
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.5007 31.0788C35.7754 30.3535 35.7754 29.1777 36.5007 28.4524L45.6931 19.26C46.4184 18.5348 47.5942 18.5348 48.3195 19.26C49.0448 19.9853 49.0448 21.1612 48.3195 21.8864L39.1271 31.0788C38.4018 31.8041 37.226 31.8041 36.5007 31.0788Z",
    fill: "#F5D016"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.3194 31.0786C47.5942 31.8039 46.4183 31.8039 45.693 31.0786L36.5007 21.8863C35.7754 21.161 35.7754 19.9851 36.5007 19.2599C37.2259 18.5346 38.4018 18.5346 39.127 19.2599L48.3194 28.4523C49.0447 29.1775 49.0447 30.3534 48.3194 31.0786Z",
    fill: "#F5D016"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2031_17433",
    x1: 42.5,
    y1: 0,
    x2: 42.5,
    y2: 84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B51F07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D1304"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2031_17433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white",
    transform: "translate(16.5 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReqHistoryIcon);
export default __webpack_public_path__ + "static/media/no-req-history-icon.9a4021fcef833f4d380f455077dfe25b.svg";
export { ForwardRef as ReactComponent };